// customer http service

import { api } from './api.config'

import request from '@/utils/request'

export default {
  company: {
    getCompanyInfo (data, params) {
      return request({
        url: api.company.getCompanyInfo,
        method: 'get',
        data,
        params,
        defaultCompany: false
      })
    }
  },
  mobile: {
    getSmartTitles (data) {
      return request({
        url: api.mobile.getSmartTitles,
        method: 'get',
        data,
        defaultCompany: false
      })
    }
  },
  buyer: {
    preOrder (data) {
      return request({
        url: api.buyer.preOrder,
        method: 'post',
        data,
        defaultCompany: false
      })
    }
  }
}
